import React from 'react'

import useSiteMetadata from '../../../../hooks/useSiteMetadata'
import useUserCategory from '../../../../hooks/useUserCategory'
import Spacer from '../../../Spacer'
import AcceptedAgreements from './AcceptedAgreements'
import PendingAgreements from './PendingAgreements'
import UpdateCoveredEntity from './UpdateCoveredEntity'

export interface AgreementsContainerProps {
  className?: string
}

const AgreementsContainer: React.FC<AgreementsContainerProps> = ({ className }) => {
  const { legalAgreements } = useSiteMetadata() || {}
  const { userCategory } = useUserCategory()
  const isPractitioner = userCategory === 'practitioner'

  return (
    <div className={className}>
      <h3>Agreements</h3>
      <Spacer size={3} />
      <PendingAgreements />
      <AcceptedAgreements />
      {isPractitioner && (legalAgreements === 'US' || legalAgreements === 'PL') && (
        <UpdateCoveredEntity />
      )}
    </div>
  )
}

export default AgreementsContainer
